import { AxiosInstance } from "axios"

export enum DeadlineMessageQuery {
    DELIVERY_DEADLINE_MESSAGE = "delivery-deadline-message",
}

export enum DeadlineMessageDisplayType {
    MODAL = "MODAL",
    CARD = "CARD",
    SNACKBAR = "SNACKBAR",
}

export enum DeadlineMessageProductFlow {
    ADD_PRODUCT = "ADD_PRODUCT",
}

export type DeadlineMessageParam = Readonly<{
    merchantId: number
    deliveryTime: string
    productWish?: boolean
    shopId: number
    priceListId: number
    // comma-joined, e.g. "21353,32399"
    productIds?: string
    productFlow?: DeadlineMessageProductFlow
}>

export type DeadlineMessageInfo = Readonly<{
    displayRule: string
    merchantMessage: string
    title?: string
}>

export type DeadlineMessageResponse = Readonly<{
    deadlineMessage: {
        isConfirmed: boolean
        // absent when isConfirmed is true
        message?: DeadlineMessageInfo
    }
    userMessage?: Readonly<{
        displayType?: string
    }>
}>

export type DeadlineMessageState = Readonly<{
    isConfirmed: boolean
    message?: DeadlineMessageInfo
    displayType: DeadlineMessageDisplayType
}>

function toDeadlineMessageDisplayType(value: string | undefined): DeadlineMessageDisplayType {
    return (
        Object.values(DeadlineMessageDisplayType).find((displayType) => displayType === value) ??
        DeadlineMessageDisplayType.MODAL
    )
}

export function selectDeadlineMessage({ deadlineMessage, userMessage }: DeadlineMessageResponse): DeadlineMessageState {
    return {
        ...deadlineMessage,
        displayType: toDeadlineMessageDisplayType(userMessage?.displayType),
    }
}

export async function fetchDeadlineMessage(
    { merchantId, ...rest }: DeadlineMessageParam,
    axios: AxiosInstance,
    signal?: AbortSignal,
): Promise<DeadlineMessageResponse> {
    const url = `merchants/${merchantId}/orders/deadlineMessage`
    const { data } = await axios.get(url, {
        signal,
        params: rest,
    })

    return data
}
